
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/africa/advisory-board",
      function () {
        return require("private-next-pages/africa/advisory-board.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/africa/advisory-board"])
      });
    }
  